import React from "react";
import { TouchableOpacity } from "react-native";
import { useTheme } from "@emotion/react";

import Text from "myplan/components/Text";
import { AppTheme } from "myplan/utils/theme";
import { TopRipBorder } from "../Fx";

import { LabelContainer } from "./styles";

const NearMeButton = ({ children, onPress = () => undefined }) => {
	const {
		color: { backgroundAccent },
	}: AppTheme = useTheme() as AppTheme;
	const topRipBorderStyle = { color: backgroundAccent };
	return (
		<TouchableOpacity onPress={onPress}>
			<>
				<TopRipBorder style={topRipBorderStyle} />
				<LabelContainer>
					<Text type="ctah5">{children}</Text>
				</LabelContainer>
			</>
		</TouchableOpacity>
	);
};

export default NearMeButton;
